import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { getFormValues, isInvalid, submit as submitForm } from 'redux-form'
import { CustomFieldsGroup } from '@lk/api'
//@ts-ignore
import { Container, SegmentGroup, GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { updateCustomFields } from '../../../store/loan'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'
//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { translate } from 'loankeeper-common/helpers'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'

import DynamicFields, { getSubmitData } from '../../DynamicFields'
import { actions as DCActions } from '../../DetailsContainer'

import { CustomFieldsProps } from '../types.LoanDetails'

const DYNAMIC_FORM_NAME = (ID: string) => `loanDetails-${ID}-customfields`
const translateLKMessage = (name: string) => translate(`LKMESSAGE-${name}`)

@withConstantPermissions()
//@ts-ignore
@connect(
  (state) => ({
    dynamicValues: (ID: string) => getFormValues(DYNAMIC_FORM_NAME(ID))(state),
    invalidFormData: (ID: string) => isInvalid(DYNAMIC_FORM_NAME(ID))(state),
  }),
  {
    submitForm,
    openErrorModal: (message: string) => LKModalActions.openError(message),
    updateCustomFields,
    afterUpdateCustomFields: (ID: string, hash: string) => DCActions.fetchPage({ type: 'Loan', ID, hash, page: 'custfields' }),
  },
)
class CustomFields extends React.Component<CustomFieldsProps> {
  handleSubmit = () => {
    const { ID, openErrorModal, invalidFormData } = this.props
    if (invalidFormData(ID)) {
      openErrorModal(translateLKMessage('ERR_FILL_REQUIRED_DYNFIELDS'))
    }
    this.props.submitForm(DYNAMIC_FORM_NAME(ID))
  }

  saveDynamicData = () => {
    const { ID, hash, dynamicValues } = this.props

    // UPDATE DATE FORMAT
    const dyanamicFieldData = dynamicValues(ID)
    const DynFieldValues = Object.keys(dyanamicFieldData).reduce(
      (result, key) => ({
        ...result,
        [key]: LKDate.isValidFormat(dyanamicFieldData[key])
          ? moment(LKDate.from(dyanamicFieldData[key]).toDate()).format('DD.MM.YYYY')
          : dyanamicFieldData[key],
      }),
      {},
    )
    const data = JSON.stringify(getSubmitData(DynFieldValues))
    // END -- UPDATE DATE FORMAT
    this.props
      .updateCustomFields({
        LoanID: ID,
        HashSum_LoanID_: hash,
        DynFieldData: data,
      })
      .then(() => this.props.afterUpdateCustomFields(ID, hash))
      .catch((e) => {
        this.props.openErrorModal(
          (e && e.Error && (e.Error.Message || e.Error.Text.replace('<', ' ').replace('>', ' '))) ||
            translateLKMessage('ERROR'),
        )
      })
  }

  render() {
    const {
      ID,
      data: { custfields, base },
      permissions,
    } = this.props

    return (
      <Container>
        <SegmentGroup>
          <Segment.Group>
            <GridContainer>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={15}>
                    <DynamicFields
                      type={CustomFieldsGroup.Loan}
                      productId={base.ProductID}
                      initialValues={custfields}
                      editing={!!permissions.CUSTFIELDS_UPDATE_LOAN}
                      onSubmit={this.saveDynamicData}
                      form={DYNAMIC_FORM_NAME(ID)}
                    />
                  </Grid.Column>

                  {permissions.CUSTFIELDS_UPDATE_LOAN && (
                    <Grid.Column width={1}>
                      <LKButton alias="save" onClick={this.handleSubmit} />
                    </Grid.Column>
                  )}
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Segment.Group>
        </SegmentGroup>
      </Container>
    )
  }
}

export default CustomFields
